import type { NextPage } from 'next'

import DesktopSolutionList from '@/components/farmerSolution/DesktopSolutionList'
import DetailedFeatureRow from '@/components/farmerSolution/DetailedFeatureRow'
import DownloadApp from '@/components/farmerSolution/DownloadApp'
import ESamadhan from '@/components/farmerSolution/ESamadhan'
import FeatureCard from '@/components/farmerSolution/FeatureCard'
import KisanAppBanner from '@/components/farmerSolution/KisanAppBanner'
import KisanAppFooterBanner from '@/components/farmerSolution/KisanAppFooterBanner'
import MobileSolutionList from '@/components/farmerSolution/MobileSolutionList'
import PremiumMembership from '@/components/farmerSolution/PremiumMembership'
import LayoutWithNavigation from '@/components/layoutWithNavigation'
import Picture from '@/components/picture'
import { ASSET_DIR, FEATURE_CARDS, STRINGS } from '@/constants/farmerSolutions'

export async function getStaticProps() {
  return {
    props: {
      title: STRINGS.PAGE_TITLE,
      description: STRINGS.PAGE_DESCRPTION,
    },
  }
}

const SolutionForFarmer: NextPage = () => (
  <LayoutWithNavigation>
    <section className="px-6 mt-4 max-w-7xl m-auto">
      <h1 className="md:hidden text-[32px] font-natosans-semibold font-semibold leading-[1.875] text-black">
        {STRINGS.PAGE_HEADING}
      </h1>
      <section className="flex md:flex-row flex-col">
        <section className="md:w-7/12 md:order-1 order-2">
          <h1 className="hidden md:block font-natasans-semibold font-semibold leading-[1.875] text-5xl text-black">
            {STRINGS.PAGE_HEADING}
          </h1>
          <article className="max-w-[630px]">
            <p className="mt-2 md:mt-8 text-base md:text-lg leading-7 whitespace-pre-wrap text-[#2f2f2f] font-natosans-light">
              {STRINGS.DESCRIPTION}
            </p>
          </article>
        </section>
        <section className="md:w-5/12 px-[15px] md:order-2 order-1">
          <Picture
            image={`${ASSET_DIR}/farmer`}
            imageAlt="A happy family of farmer"
          />
        </section>
      </section>
    </section>
    <KisanAppBanner />
    <section className="px-6 mb-4 max-w-7xl m-auto">
      <section className="grid md:grid-cols-3 grid-cols-1 md:mt-14 mt-8 md:gap-x-[4%]">
        {FEATURE_CARDS.map((feature) => (
          <FeatureCard key={feature.heading} {...feature} />
        ))}
      </section>
      <section className="md:mt-[130px] mt-14">
        <h2 className="md:text-5xl text-[32px] md:mb-[17px] font-natosans-semibold font-semibold text-[#101010] leading-[1.1875]">
          {STRINGS.DIGITAL_SOLUTION}
        </h2>
        <DesktopSolutionList />
        <MobileSolutionList />
      </section>
    </section>
    <DownloadApp />
    <section className="px-6 my-4 max-w-7xl m-auto">
      <header>
        <h2 className="md:text-5xl text-[32px] font-natosans-semibold font-semibold text-[#101010] text-center mt-5 mb-2.5 leading-[1.1875]">
          {STRINGS.FIVE_A}
        </h2>
        <span className="w-20 h-2 bg-[#0b8040] mt-4 mx-auto rounded-[10px] block" />
      </header>
      <section className="mt-11 md:mt-[173px] md:mb-[59px] mb-[37px]">
        <DetailedFeatureRow
          heading={STRINGS.ACCESS_QUALITY_INPUT}
          image={`${ASSET_DIR}/access-quality-input`}
          description={STRINGS.ACCESS_QUALITY_INPUT_DESC}
        />
        <DetailedFeatureRow
          heading={STRINGS.AFFORDABLE_INSURANCE}
          image={`${ASSET_DIR}/bima-shield`}
          description={STRINGS.AFFORDABLE_INSURANCE_DESC}
          reverse
        />
        <DetailedFeatureRow
          heading={STRINGS.FORMAL_CREDIT}
          image={`${ASSET_DIR}/formal-credit`}
          description={STRINGS.FORMAL_CREDIT_DESC}
        />
        <DetailedFeatureRow
          heading={STRINGS.ACTIONABLE_ADVISORY}
          image={`${ASSET_DIR}/actionable-advisory`}
          description={STRINGS.ACTIONABLE_ADVISORY_DESC}
          reverse
        >
          <ESamadhan />
        </DetailedFeatureRow>
        <DetailedFeatureRow
          heading={STRINGS.PROFITABLE_MARKET}
          description={STRINGS.PROFITABLE_MARKET_DESC}
          image={`${ASSET_DIR}/profitable-markets`}
        />
      </section>
    </section>
    <section className="bg-neutral-10">
      <PremiumMembership />
      <KisanAppFooterBanner />
    </section>
  </LayoutWithNavigation>
)

export default SolutionForFarmer
